<div class="mb-4 flex items-center justify-between">
	<div class="text-base font-bold text-black">User Management</div>
	<div>
		<button (click)="createNewUser()" class="aa-btn" data-variant="primary" data-size="small">
			<span class="aa-mat-icon !text-white">add_box</span>
			Add User
		</button>
	</div>
</div>

<div class="mb-4 flex items-center justify-between gap-4">
	<div class="max-w-xs flex-1">
		<div class="relative">
			<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field form-field-sm w-full">
				<input
					matInput
					[(ngModel)]="searchQuery"
					(input)="onSearch()"
					placeholder="Search Staff Name/Email"
					class="pr-10"
				/>
				<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_search.svg" alt="Search" />
			</mat-form-field>
		</div>
	</div>

	<div class="w-[220px]">
		<mat-form-field appearance="outline" subscriptSizing="dynamic" class="form-field form-field-sm w-full">
			<mat-select [(value)]="selectedRole" (selectionChange)="onRoleFilter()" placeholder="Filter">
				<mat-option value="">All</mat-option>
				@for (roleOption of rolesOptions; track roleOption) {
					<mat-option [value]="roleOption.code">{{ roleOption.code | titlecase }}</mat-option>
				}
			</mat-select>
			<img class="absolute right-1 top-1/2 w-3 -translate-y-1/2" src="/assets/icon_filter.svg" alt="Filter" />
		</mat-form-field>
	</div>
</div>

<div class="cbta-tbl users-tbl">
	<div class="columns">
		<div class="column col-12">
			<ngx-table
				[configuration]="configuration"
				[data]="users"
				[noResultsTemplate]="noResultsTemplate"
				[columns]="columns"
				[pagination]="pagination"
				(event)="onTableChanged($event)"
			>
			</ngx-table>
		</div>

		<ng-template #userNameTpl let-row let-rowIndex="rowIndex">
			<span class="font-bold uppercase">{{ row.name }}</span>
			@if (row.is_external) {
				<span class="ml-2 rounded bg-red-100 px-2 py-0.5 text-xs font-medium text-red-600">External</span>
			}
		</ng-template>

		<ng-template #emailTpl let-row let-rowIndex="rowIndex">
			<span>{{ row.email }}</span>
		</ng-template>

		<ng-template #roleTpl let-row let-rowIndex="rowIndex">
			<div class="gap-1">
				@for (role of row.roles; track role) {
					<span>{{ role | titlecase }}</span
					><br />
				}
			</div>
		</ng-template>

		<ng-template #actionTpl let-row let-rowIndex="rowIndex">
			<div class="flex justify-center">
				<button [matMenuTriggerFor]="actionMenu" [matMenuTriggerData]="{ row, rowIndex }">
					<mat-icon>more_vert</mat-icon>
				</button>
			</div>
		</ng-template>

		<ng-template #noResultsTemplate>
			<td [attr.colspan]="columns.length" class="h-[180px] text-center">
				<span class="text-grey-40">
					@if (searchQuery || selectedRole) {
						No users found.
					}
				</span>
			</td>
		</ng-template>
	</div>
</div>

<mat-menu #actionMenu="matMenu" class="!min-w-36 border border-[#CFE3FF] px-1 !shadow-sm">
	<ng-template matMenuContent let-row="row" let-index="rowIndex">
		<button class="menu-btn" (click)="editUser(row.id)" [disabled]="!isOnline">
			<span>Edit</span>
		</button>
		<button class="menu-btn hover:!bg-red" (click)="deleteUser(row.id)" [disabled]="!isOnline">
			<span>Delete</span>
		</button>
	</ng-template>
</mat-menu>
